var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data.columns),function(col,index){return _c('div',{key:'col' + index,class:['col-' + col.colsMobile, 'col-lg-' + col.colsDesktop]},[_c('div',{staticClass:"container-content__column",domProps:{"innerHTML":_vm._s(col.htmlContent)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }